import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService, MoneyAccount } from '@rollit/shared/data';
import { UIManagerService } from '@rollit/shared/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoanService } from '../loan.service';
@Component({
  selector: 'app-credit-cards-loans',
  templateUrl: './credit-cards-loans.component.html',
  styleUrls: ['./credit-cards-loans.component.scss']
})
export class CreditCardsLoansComponent implements OnInit, OnDestroy {
  log: any;
  isDesktop = false;
  private isDestroyed = new Subject();
  sliding = false;
  sectionValue: Subject<string> = new Subject();
  totalAccountValue = 0;
  currentSlide = 0;
  currentViewSlide = 0;
  activeRoute = 'credit';
  useLatest = false;
  accounts: MoneyAccount[] = [];
  expanded = false;
  ready: boolean;
  mobileAnimating: boolean;

  constructor(
    private loanService: LoanService,
    private logger: LoggerService,
    private uiService: UIManagerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.log = this.logger.info('CreditCardsLoansComponent');

    this.uiService.displayContentAsFullPage.next(true);
    this.uiService.sideNavIsVisible.next(true);
    this.uiService.mediaSizeIsDesktop$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((mediaSizeIsDesktop) => {
        this.isDesktop = mediaSizeIsDesktop;
      });



  }

  ngOnInit() {
    this.loanService.getAccounts().subscribe(result => {
      this.accounts = result;
      this.log(this.accounts);
      this.accounts.forEach((ac) => {
        this.log('ac', ac);
        this.totalAccountValue += ac.currentBalance;
      });
      this.log('sort this.accounts', this.accounts);
      this.ready = true;
      this.checkSlideIndex();
    });
  }

  ngOnDestroy(): void {
    this.uiService.displayContentAsFullPage.next(false);
    this.uiService.sideNavIsVisible.next(false);
    this.isDestroyed.next();
    this.isDestroyed.complete();
  }

  checkSlideIndex() {
    const activeId = this.activatedRoute.snapshot.paramMap.get('id');
    this.log('activeId', activeId);
    if (activeId === 'latest') {
      this.log('checkSlideIndex latest yes');
      this.useLatest = true;
      this.router.navigate([this.activatedRoute.snapshot.url[0] + '/' + 0], {
        queryParamsHandling: 'merge',
        replaceUrl: true,
      }).then(() => {
        this.setSlideIndex();
      });
    } else if (activeId && !Number.isNaN(+activeId)) {
      this.log('activeId yes', +activeId);
      this.currentSlide = +activeId;
      if (!this.isDesktop) {
        this.mobileScrollToSection(this.currentSlide);
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.url[0] + '/' + 0], {
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
  }

  setSlideIndex() {
    const tempArray = Object.assign([], this.accounts);
    this.log('sort this.accounts', tempArray, this.accounts);
    const latestObj = tempArray.sort((a, b) => new Date(b.timeCreated).getTime() - new Date(a.timeCreated).getTime())[0];
    this.log('sort latest', latestObj);
    const isNew = this.isNew(latestObj.timeCreated);
    this.log('sort isNew', isNew);
    if (isNew) {
      const index = this.accounts.findIndex(x => x.id === latestObj.id);
      this.log('sort index', index);
      this.log('sort this.accounts', tempArray, this.accounts);
      this.currentSlide = index;
    }
  }

  isNew(createdDate) {
    const today = new Date().getTime();
    createdDate = new Date(createdDate).getTime();
    this.log('sort', today, createdDate, today - createdDate, 5 * 60 * 1000);
    return Math.abs(today - createdDate) < 5 * 60 * 1000;
  }


  onEditLoan(accountId: number) {
    this.loanService.startUpdateLoan(accountId);
  }

  onCreateLoan() {
    this.router.navigate([this.activatedRoute.snapshot.url[0] + '/latest'], {
      queryParamsHandling: 'merge',
      replaceUrl: true,
    }).then(() => {
      this.loanService.startAddLoan();
    });

  }

  expandedEvent(expanded) {
    this.expanded = expanded;
    this.onElementScroll();
  }

  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    // this.log('window:resize');
    this.sectionValue.next(this.accounts[this.currentSlide].id.toString());
  }


  scrollPrev() {
    this.log('scrollPrev()', this.currentSlide + ' <> ' + this.accounts.length, this.sliding);
    if (this.currentSlide > 0) {
      this.sliding = true;
      this.currentSlide--;
      this.sectionValue.next(this.accounts[this.currentSlide].id.toString());
    }
  }

  scrollNext() {
    this.log('scrollNext()', this.currentSlide + ' <> ' + this.accounts.length, this.sliding);
    if (this.currentSlide < this.accounts.length - 1) {
      this.sliding = true;
      this.currentSlide++;
      this.log(this.currentSlide);
      this.sectionValue.next(this.accounts[this.currentSlide].id.toString());

    }
  }


  animationCallback(event) {
    this.log(event);
    this.sliding = false;
    this.currentViewSlide = this.currentSlide;
    this.router.navigate([this.activatedRoute.snapshot.url[0] + '/' + this.currentViewSlide], {
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  mobileScrollToSection(slideId) {
    this.log('mobileScrollToSection', slideId);
    if (slideId > 0) {
      this.mobileAnimating = true;
      const topTargetId = this.accounts[slideId].id;
      this.log('mobileScrollToSection topTargetId', topTargetId);
      const topTarget = document.getElementById(topTargetId.toString());
      this.log('mobileScrollToSection topTarget', topTarget);

      if (topTarget !== null) {
        setTimeout(() => {
          topTarget.scrollIntoView({
            block: "start",
            behavior: 'smooth',
          });

          setTimeout(() => {
            this.mobileAnimating = false;
          }, 500);
        }, 300);
      } else {
        this.log('mobileScrollToSection not ready');
        setTimeout(() => {
          this.mobileScrollToSection(slideId);
        }, 50);
      }
    }
  }


  onElementScroll() {
    if (!this.isDesktop && !this.mobileAnimating) {
      const scrollTarget = document.getElementsByClassName("section-content")[0];
      const allSections = document.getElementsByTagName('app-credit-cards-loans-hero');

      let lastEl;
      for (let i = 0; i < allSections.length; i++) {
        const htmlElement = allSections[i] as HTMLElement;
        const elBottomAboveHalfView = (scrollTarget.scrollTop + scrollTarget.clientHeight / 2) > (htmlElement.offsetTop + htmlElement.offsetHeight);
        const elTopAboveBottomView = (scrollTarget.scrollTop + scrollTarget.clientHeight) > htmlElement.offsetTop;
        const elTopAboveHalfView = (scrollTarget.scrollTop + scrollTarget.clientHeight / 2) > htmlElement.offsetTop;

        if (!elBottomAboveHalfView && elTopAboveBottomView && elTopAboveHalfView) {
          this.log('htmlElement', htmlElement.id);
          lastEl = htmlElement;
          this.router.navigate([this.activatedRoute.snapshot.url[0] + '/' + i], {
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
      }

      this.log('scroll', lastEl);
    }
  }

  startNewGoal() {
    this.log('starting new goal service.');
    this.loanService.startNewGoal(this.accounts[this.currentSlide]);
  }
}
